module.exports = __webpack_public_path__ + "themes/fq/font/proximasoft-regular-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/proximasoft-regular-webfont.ttf
// module id = 95
// module chunks = d-game